import React, { useEffect } from 'react';
import {useDispatch} from "react-redux";
import {useRouter} from "react-router5";
import {askPin} from "../redux/pin/pinSlice";
// User has switched back to the tab


// User has switched away from the tab (AKA tab is hidden)
const onBlur = (dispatch) => {
    // PIN: deactivate
    // dispatch(askPin({value : false , redirectUrl : window.location.pathname}))
};

const WindowFocusHandler = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        window.addEventListener('blur', ()=>{onBlur(dispatch)});
        // Specify how to clean up after this effect:
        return () => {
            window.removeEventListener('blur', onBlur);
        };
    });

    return <></>;
};

export default WindowFocusHandler;
